const dataSet = document.getElementById('root').dataset;
const startDate = dataSet.salesdatestart;
const venue = dataSet.venueid;

/**
 * Statistics header tabs config
 */
export default [
    {
        name: 'Sale',
        link: `/bloodstock/sales/statistics/${venue}/${startDate}`,
    },
    {
        name: 'Sires',
        link: `/bloodstock/sales/statistics/${venue}/${startDate}/sires`,
    },
    {
        name: 'Buyers',
        link: `/bloodstock/sales/statistics/${venue}/${startDate}/buyers`,
    },
    {
        name: 'Vendors',
        link: `/bloodstock/sales/statistics/${venue}/${startDate}/vendors`,
    }
];



// WEBPACK FOOTER //
// ./src/js/config/tabsConfigStatistics.js